import React, { useEffect, useCallback, useState} from 'react';
import {
    setQuickAddSearchText} from 'actions/index.js';
import Dropdown from 'react-dropdown';
import {connect} from 'react-redux';
import {MULTI_SYNTH, SAMPLED_INSTRUMENT} from 'constants/instrument-types.js';
import {INSTRUMENT_RACK} from 'constants/track-types.js';

const TYPE_OPTIONS = [
    {label: "Instrument", value: SAMPLED_INSTRUMENT},
    {label: "Rack", value: INSTRUMENT_RACK},
    {label: "Synth", value: MULTI_SYNTH},
];

const PresetsToolbar = ({
    type,
    instrumentType,
    setInstrumentType,
    tags,
    setSearchTerm,
    setPresetsToShow,
    searchTerm='',
    onChange,
    setSearchText,
    filterFavorites,
    setFilterFavorites,
    setGroupByPacks,
    groupByPacks,
}) => { 
    let options = tags.map(x => ({
        label: x,
        value: x
    }));

    const _onChange = useCallback((o) => {
        console.log("_onChange=", o.value);
        onChange(undefined, o.value);
    }, [onChange, setSearchTerm, setPresetsToShow]);

    return (
        <div className="presets-toolbar">
          <div
            onClick={() => setFilterFavorites(!filterFavorites)}
            className={filterFavorites ? "heart favorited" : "heart"}/>
          <div
            onClick={() => setGroupByPacks(!groupByPacks)}
            className={groupByPacks ? "packs-btn selected" : "packs-btn"}/>
          {groupByPacks && <div className="packs-text">Packs</div>}
          {/*
          {type === INSTRUMENT_RACK ? 
           <Dropdown
             options={TYPE_OPTIONS}
             value={TYPE_OPTIONS.find(x => x.value === instrumentType)}
             onChange={x => setInstrumentType(x.value) }
           /> : ''}

          <Dropdown
            options={options}
            value={options.find(x => x.value === searchTerm)}
            onChange={_onChange}
            placeholder="Filter by type"
          />
          <div onClick={() => {
              onChange(undefined, '');
              setSearchText('');
          }} className={searchTerm === '' ? "clear-btn disabled" : "clear-btn"}>
            x
          </div>
           */}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setSearchText: x => dispatch(setQuickAddSearchText(x)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PresetsToolbar);
